import { Model as t } from "../../../../model.js";
class p extends t {
  constructor(s) {
    super(), this.newStatus = s.newStatus, this.previousStatus = s.previousStatus, this.timestamp = s.timestamp;
  }
}
export {
  p as TicketHistoryStatusModel
};
//# sourceMappingURL=ticketHistoryStatus.model.js.map
